export type EmailSubscriptionRequest = {
    email: string,
    template_type: EmailTemplateType,
    status?: EmailSubscriptionStatus
}

export enum EmailTemplateType {
    MONTHLY_STATS_EMAIL = "monthly_stats_email",
    GENERIC_EMAIL = "generic_email",
    Monthly_Status_Executive = "monthly_status_executive_email",

    CALL_FINAL = "AccountCreatedFunnel/CallFinal",
    CALL_TO_CONVERT_1 = "AccountCreatedFunnel/CallToConvert1",
    RESULTS_UPDATE_1 = "AccountCreatedFunnel/ResultsUpdate1",
    WELCOME = "AccountCreatedFunnel/Welcome",

    SUBSCRIPTION_WELCOME = "SubscriptionFunnel/SubscriptionWelcome",
    SUBSCRIPTION_PRODUCT_UPDATE = "SubscriptionFunnel/SubscriptionProductUpdate",
    DATADELETION_UPDATE = "SubscriptionFunnel/DataDeletionUpdate",
    DATADELETION_UPDATE_PROMO = "SubscriptionFunnel/DataDeletionUpdatePromo",
    SUBSCRIPTION_FEEDBACK = "SubscriptionFunnel/SubscriptionFeedback",

    EMPLOYEE_UPDATE_1 = "CorporateFunnel/EmployeeUpdate1",
    EMPLOYEE_UPDATE_2 = "CorporateFunnel/EmployeeUpdate2",

    CORPORATE_INVITE_NEW_USER = "CorporateInviteNewUser",
    CORPORATE_INVITE_EXISTING_USER = "CorporateInviteExistingUser",
    CORPORATE_EXECUTIVE_INVITE_NEW_USER = "CorporateExecutiveInviteNewUser",
    FAMILY_INVITE_NEW_USER = "FamilyInviteNewUser",
    FAMILY_INVITE_EXISTING_USER = "FamilyInviteExistingUser"
}
enum EmailSubscriptionStatus {
    SUBSCRIBED = "subscribed",
    UNSUBSCRIBED = "unsubscribed"
}
